import "./AboutUs.css";
import ComingSoon from "../img/ComingSoon.png";

function AboutUs() {
  return (
    <div className="about-us-container">
      <img className="comingsoon" src={ComingSoon} alt="Coming Soon" />
    </div>
  );
}

export default AboutUs;